module.exports = __webpack_public_path__ + "static/media/VeggieAnimal.af5f48fe.jpg";